import { BrowserGateShell } from "../components/BrowserGateShell";
import { APP_STORE_URL } from "../lib/appClient";

export default function DownloadAppPage() {
  return (
    <BrowserGateShell>
      <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">Setback Pitch</h1>
      <p className="mt-3 text-lg text-white/80 sm:text-xl">
        The classic card game — now on iPhone
      </p>

      <p className="mt-8 text-base leading-relaxed text-white/70">
        Play Setback Pitch with friends. Free for 14 days, then $1.99 for lifetime access.
      </p>

      <a
        href={APP_STORE_URL}
        className="mt-10 inline-flex w-full max-w-xs items-center justify-center rounded-xl bg-emerald-500 px-6 py-3.5 text-base font-semibold text-slate-900 shadow-lg transition hover:bg-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-2 focus:ring-offset-[#0f3d25]"
      >
        Download on the App Store
      </a>
    </BrowserGateShell>
  );
}
